import { makeStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { fontSize } from '../../../../styles/themes/vad/font';

// TODO: Use react-truncate package when available

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
    marginTop: pxToRem(78),
    marginBottom: pxToRem(78),
    [theme.breakpoints.down('md')]: {
      marginTop: pxToRem(64),
      marginBottom: pxToRem(0),
    },
  },
  sponsorGridWrapper: {
    '@media (max-width: 370px)': {
      marginLeft: pxToRem(12),
      marginRight: pxToRem(12),
    }
  },
  sponsorList: {
    marginTop: '32px',
    marginBottom: '86px',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    padding: '0px',
    flex: 'none',
    order: 1,
    alignSelf: 'stretch',
    flexGrow: 0,
    justifyContent: 'flex-start',
    [theme.breakpoints.down('md')]: {
      marginTop: '40px',
      marginBottom: '64px',
      justifyContent: 'space-between',
      gap: '20px',
    },
    '@media (max-width: 370px)': {
      gap: '15px',
    },
    '@media (max-width: 308px)': {
      justifyContent: 'center',
    }
  },
  poppedItemWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    padding: '0px',
    flex: 'none',
    order: 1,
    alignSelf: 'stretch',
    flexGrow: 0,
    [theme.breakpoints.down('md')]: {
      marginTop: '-30px',
      marginBottom: '64px',
      justifyContent: 'center',
      gap: '20px',
    }
  },
  sponsorItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px 13px',
    gap: '10px',
    flexBasis: '16.6666%',
    width: '209px',
    height: '100px',

    '& picture': {
      width: '158px',
      // height: '52px',

      '& img': {
        objectFit: 'scale-down',
        imageRendering: '-webkit-optimize-contrast',
      }
    },

    '@media (min-width: 1800px)': {
      flexBasis: '12.5%',
    },

    [theme.breakpoints.down('md')]: {
      width: '147.5px',
      height: '64px',
      padding: '0px',
      '& picture': {
        width: '146px',
        // height: '48px',
      },
    },
    '@media (max-width: 1240px)': {
      width: '147.5px',
      '& picture': {
        width: '147.5px',
      },
    },
    '@media (max-width: 370px)': {
      width: '134px',
      height: '64px',
      padding: '0px',
      '& picture': {
        width: '134px',
        // height: '48px',
      },
    },
  }
}));

export default useStyles;
